<template>
  <div class="configurator-start">
    <div class="einleitung">
      <div class="text">
        <div class="headline" v-text="$ml.get('title')"></div>
        <div class="absatz" v-text="$ml.get('instruction')"></div>
      </div>
      <div class="rutschen-image-wrapper">
        <!-- <picture class="rutschen-image">
          <source media="(max-width: 450px)" srcset="../assets/background_rutsche_w400.jpg 400w" />
          <source media="(max-width: 575px)" srcset="../assets/background_rutsche_w570.jpg 570w" />
          <source media="(max-width: 767px)" srcset="../assets/background_rutsche_w570.jpg 570w" />
          <source media="(max-width: 991px)" srcset="../assets/background_rutsche_w360.jpg 360w" />
          <source media="(max-width: 1199px)" srcset="../assets/background_rutsche_w480.jpg 480w" /> -->
        <img
          src="../assets/schwedt/rutsche-aussen.jpg"
          alt="Rutschen erlebnis"
          class="rutschen-image"
        />
        <!-- </picture> -->
      </div>
    </div>
    <div class="container input-container">
      <div class="card-input-wrapper">
        <div class="card-input-container">
          <!-- rutschenname -->
          <div class="card-input-description" v-text="$ml.get('nameIt')"></div>
          <b-input-group id="input-group-name">
            <b-input-group-prepend>
              <span class="input-group-text">
                <PenIcon title />
              </span>
            </b-input-group-prepend>
            <b-form-input
              id="input-name"
              v-model="internalName"
              :maxlength="20"
              type="text"
              required
              placeholder="z.B. Speedrun 2000"
              class="input-with-icon"
              change="$emit('change')"
              @keydown.enter="$emit('start', internalName)"
            />
          </b-input-group>
        </div>
      </div>
    </div>
    <hr />
    <div class="container input">
      <button
        class="btn abort-btn"
        style="margin-right: 5px;"
        @click="$emit('cancel')"
        v-text="$ml.get('btnCancel')"
      ></button>
      <button
        class="btn start-btn"
        :class="{ 'disableButton disabled': validNextStep }"
        style="margin-left: 5px;"
        @click="$emit('start', internalName)"
        v-text="$ml.get('btnGo')"
      ></button>
    </div>
  </div>
</template>

<script>
import PenIcon from "vue-material-design-icons/Pencil";

export default {
  name: "ConfiguratorStart",
  components: {
    PenIcon,
  },
  props: {
    name: {
      type: String,
      default: "",
      required: true,
      validator: (value) => {
        if (value.length === 0) {
          return true;
        } else return value.length > 0 && value.length < 20;
      },
    },
  },
  data() {
    return {
      internalName: "",
    };
  },
  computed: {
    validName() {
      if (this.internalName.length === 0) return null;
      else return this.internalName.length > 0 && this.internalName.length < 17;
    },
    validNextStep() {
      return this.internalName.length < 1;
    },
  },
  watch: {
    name: {
      handler: function(newVal) {
        this.internalName = newVal;
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.configurator-start {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container.input-container {
  padding-left: 30px;
  padding-right: 30px;
}

.einleitung {
  display: flex;
  flex-direction: row;
}

.text {
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 50%;
  padding-left: 30px;
  padding-right: 30px;
}

.rutschen-image-wrapper {
  width: 50%;
  height: 300px;
}

.rutschen-image {
  height: 100%;
  width: 100%;
  margin-top: -16px;
}

@media (max-width: 767px) {
  .rutschen-image {
    height: auto;
  }
}

.text .headline {
  font-size: 1.3rem;
  font-weight: bold;
}

.disableButton {
  pointer-events: none;
}

.card-input-wrapper {
  text-align: left;
  margin-top: -40px;
  min-width: 650px;
  align-self: center;
}

.configurator-start .container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-input-description {
  padding-left: 15px;
}

.input {
  justify-content: space-between;
  padding-bottom: 20px;
}

.input .btn {
  width: 150px;
}

hr {
  border-top: 2px solid rgba(255, 255, 255, 0.1) !important;
  width: 100%;
}

@media (max-width: 768px) {
  .einleitung {
    flex-direction: column;
  }

  .einleitung,
  .container.input-container {
    padding-left: 15px;
    padding-right: 15px;
  }

  .text,
  .rutschen-image-wrapper {
    width: 100%;
  }

  .rutschen-image {
    margin-top: 5px;
  }

  .text {
    padding: 0;
  }

  .card-input-wrapper {
    min-width: 100%;
  }
}
</style>
